if (!customElements.get('learn-formula-compare')) {
  class LearnFormulaCompare extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          this.select(index, true);
          const top = this.getBoundingClientRect().top;
          if (top < 0) {
            const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            window.scrollTo({ top: top + window.scrollY + 16, behavior: smooth ? 'smooth' : 'auto' });
          }
        });
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });

      this.toggles = Array.from(this.querySelectorAll('[data-toggle]'));
      this.toggles.forEach((button) => {
        button.addEventListener('click', () => {
          const open = button.getAttribute('aria-expanded') !== 'true';
          this.toggles.forEach((toggle) => this.setDetails(toggle, open));
        });
      });

      if (!LearnFormulaCompare.linksBound) {
        LearnFormulaCompare.linksBound = true;
        document.addEventListener('click', (event) => {
          const link = event.target.closest('[data-learn-formula]');
          if (!link) return;
          const handle = link.dataset.learnFormula;
          const owner = Array.from(document.querySelectorAll('learn-formula-compare')).find((el) =>
            el.querySelector(`[role="tab"][data-formula="${handle}"]`)
          );
          if (!owner) return;
          event.preventDefault();
          owner.openFormula(handle, true);
          history.replaceState(null, '', `#formula-${handle}`);
        });
      }

      const hash = window.location.hash.replace('#formula-', '');
      if (window.location.hash.startsWith('#formula-') && this.querySelector(`[data-formula="${hash}"]`)) {
        requestAnimationFrame(() => this.openFormula(hash, true));
      }

      this.addEventListener('shopify:block:select', (event) => {
        let index = this.tabs.findIndex((tab) => tab.contains(event.target));
        if (index === -1) index = this.panels.findIndex((panel) => panel.contains(event.target));
        if (index > -1) this.select(index, false);
      });
    }

    setDetails(button, open) {
      if ((button.getAttribute('aria-expanded') === 'true') === open && !button.nextElementSibling?.animation) return;
      const details = button.nextElementSibling;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!details || reduce || !details.offsetParent) {
        if (details?.animation) details.animation.cancel();
        button.setAttribute('aria-expanded', String(open));
        return;
      }
      if (details.animation) details.animation.cancel();
      if (open) button.setAttribute('aria-expanded', 'true');
      const height = `${details.scrollHeight}px`;
      details.style.overflow = 'hidden';
      details.animation = details.animate(
        open
          ? [{ height: '0px', opacity: 0 }, { height, opacity: 1 }]
          : [{ height, opacity: 1 }, { height: '0px', opacity: 0 }],
        { duration: 320, easing: 'cubic-bezier(0.25, 0.8, 0.25, 1)' }
      );
      details.animation.onfinish = () => {
        details.style.overflow = '';
        details.animation = null;
        if (!open) button.setAttribute('aria-expanded', 'false');
      };
    }

    openFormula(handle, scroll) {
      const index = this.tabs.findIndex((tab) => tab.dataset.formula === handle);
      if (index === -1) return;
      this.select(index, false);
      if (!scroll) return;
      const top = this.getBoundingClientRect().top + window.scrollY + 16;
      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top, behavior: smooth ? 'smooth' : 'auto' });
      const settle = () => {
        window.removeEventListener('scrollend', settle);
        const off = this.getBoundingClientRect().top;
        if (off > -16) window.scrollBy({ top: off + 16, behavior: 'auto' });
      };
      window.addEventListener('scrollend', settle);
      setTimeout(settle, 1200);
      this.tabs[index].focus({ preventScroll: true });
    }

    select(index, focus) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', String(active));
        tab.setAttribute('tabindex', active ? '0' : '-1');
        if (active) {
          if (focus) tab.focus({ preventScroll: true });
          const list = tab.parentElement;
          const left = tab.offsetLeft - (list.clientWidth - tab.offsetWidth) / 2;
          list.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
      });

      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
        if (i === index) {
          const track = panel.querySelector('[data-track]');
          if (track) track.scrollLeft = 0;
        }
      });
    }

    onKeydown(event, index) {
      const last = this.tabs.length - 1;
      let next = null;
      if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
      if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = last;
      if (next === null) return;
      event.preventDefault();
      this.select(next, true);
    }

  }

  customElements.define('learn-formula-compare', LearnFormulaCompare);
}
